export default {
    navigationBarTitleText: "修改计划",
  };
  